<template>
  <div class="col-12 col-md-12 col-lg-10">
    <div class="tit text-center">
      <p>Certo, por favor, forneça os dados do seu contador</p>
    </div>
    <div class="row justify-content-center">
      <div class="col-12 col-md-12 col-lg-9 col-xl-9">
        <form @submit="onSubmit">
          <div class="form-row">
            <div class="form-group col-12 col-md-5">
              <label>Nome</label>
              <input v-model="nomeCompleto" type="text" required placeholder="Nome Completo"/>
            </div>
            <div class="form-group col-12 col-md-4">
              <label>E-mail</label>
              <input v-model="email" type="email" required placeholder="E-mail"/>
            </div>
            <div class="form-group col-12 col-md-3">
              <label>Telefone</label>
              <input v-model="telefone" type="text" required placeholder="Telefone" v-mask="'phone'"/>
            </div>
          </div>
          <div class="text-center fixedOptions">
            <button v-focus class="btn btn-lg btn-primary">Próximo</button>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    const accountant = this.solicitacao.Empresa.Contador
    return {
      nomeCompleto: accountant ? accountant.NomeCompleto : null,
      email: accountant ? accountant.Email : null,
      telefone: accountant ? accountant.Telefone : null
    }
  },
  props: {
    solicitacao: {required: true, type: Object}
  },
  methods: {
    onSubmit(e) {
      e.preventDefault()
      this.$emit('on-submit', {
        Empresa: {
          Contador: {
            NomeCompleto: this.nomeCompleto,
            Email: this.email,
            Telefone: this.telefone
          }
        }
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/AdditionalInformationPeerToPeer/AccountantDataStep.vue